// src/contexts/pedidos/ChatContatoContext.js
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { putData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import { useWhatsAppWeb } from './WhatsappWebContext';

const ChatContatoContext = createContext();

export const useChatContato = () => useContext(ChatContatoContext);

export const ChatContatoProvider = ({ children }) => {
  const [savingContato, setSavingContato] = useState(false);
  const { showAlert } = useAlert();
  const { showMessage } = useMessage();
  const { atualizarContatoLocal } = useWhatsAppWeb();

  const updateChatContato = useCallback(async (contato, nome, desativarIA = false) => {
    const nomeTratado = (nome || '').trim();

    if (!contato) {
      showMessage('Contato invalido para alteracao.', 'warning');
      return null;
    }

    if (!nomeTratado) {
      showMessage('Informe o nome do contato.', 'warning');
      return null;
    }

    const payload = {
      id: contato?.id ?? 0,
      dataHora: contato?.dataHora ?? contato?.ultimaDataHora ?? new Date().toISOString(),
      telefone: contato?.telefone || '',
      nome: nomeTratado,
      mensagem: contato?.mensagem ?? contato?.ultimaMensagem ?? '',
      desativarIA: !!desativarIA,
    };

    setSavingContato(true);
    try {
      const result = await putData('/ChatContato/AlteraNomeContato', payload);
      const contatoAtualizado = {
        ...contato,
        ...payload,
        ...(result || {}),
      };
      atualizarContatoLocal(contatoAtualizado);
      showAlert('Contato alterado com sucesso!');
      return contatoAtualizado;
    } catch (error) {
      console.error('Erro ao atualizar contato:', error);
      showMessage(`Erro ao atualizar contato!\n${error?.message || error}`, 'danger');
      throw error;
    } finally {
      setSavingContato(false);
    }
  }, [atualizarContatoLocal, showAlert, showMessage]);

  const value = useMemo(() => ({
    savingContato,
    updateChatContato,
  }), [savingContato, updateChatContato]);

  return (
    <ChatContatoContext.Provider value={value}>
      {children}
    </ChatContatoContext.Provider>
  );
};
